import { render } from "./OpeningHoursByDateInput.vue?vue&type=template&id=366ddb4e"
import script from "./OpeningHoursByDateInput.vue?vue&type=script&lang=js"
export * from "./OpeningHoursByDateInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__